import { Grid, Skeleton } from '@mui/material';

const ProfileSkeleton = () => {
  return (
    <div style={{ margin: '0 12px' }}>
      {[...Array(2)].map((_, index) => (
        <Grid
          container
          xs={12}
          marginTop={index === 0 ? '88px' : '25px'}
          padding="24px 24px 37px"
          bgcolor="#EEEEEE"
          borderRadius="16px"
          justifyContent="center"
        >
          <Skeleton
            animation="wave"
            variant="rectangular"
            width={115}
            height={35}
            sx={{ borderRadius: '16px', mb: '38px' }}
          />
          <Grid item xs={12}>
            {[...Array(4)].map((_, index) => (
              <Skeleton
                key={index}
                animation="wave"
                variant="rectangular"
                width={'100%'}
                height={23}
                sx={{ borderRadius: '16px', mb: '24px' }}
              />
            ))}
          </Grid>
          <Grid
            item
            xs={12}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Skeleton
              animation="wave"
              variant="rectangular"
              width={'80%'}
              height={23}
              sx={{ borderRadius: '16px' }}
            />
            <Skeleton
              animation="wave"
              variant="rectangular"
              width={45}
              height={45}
              sx={{ borderRadius: '50%' }}
            />
          </Grid>
        </Grid>
      ))}

      <Skeleton
        animation="wave"
        variant="rectangular"
        width={90}
        height={45}
        sx={{ borderRadius: '16px', mt: 6, mr: 'auto' }}
      />
    </div>
  );
};

export default ProfileSkeleton;
